import React from "react";
import MobileWebCamSetup from "./MobileWebCamSetup";
import type { HandDetector } from "@tensorflow-models/hand-pose-detection";
import type { ObjectDetection } from "@tensorflow-models/coco-ssd";

interface MobileWebcamStepProps {
  instructions: string[];
  onSetupComplete?: (isComplete: boolean) => void;
  handDetector?: HandDetector | null;
  objectDetector?: ObjectDetection | null;
  detectionStatusMessage?: string;
  isDetectionPreparing?: boolean;
  detectionError?: Error | null;
  footer?: React.ReactNode;
}

const MobileWebcamStep: React.FC<MobileWebcamStepProps> = ({
  instructions,
  onSetupComplete,
  handDetector,
  objectDetector,
  detectionStatusMessage,
  isDetectionPreparing,
  detectionError,
  footer,
}) => {
  return (
    <MobileWebCamSetup
        instructions={instructions}
        onSetupComplete={onSetupComplete}
        handDetector={handDetector}
        objectDetector={objectDetector}
        detectionStatusMessage={detectionStatusMessage}
        isDetectionPreparing={isDetectionPreparing}
        detectionError={detectionError}
        footer={footer}
    />
  );
};

export default MobileWebcamStep;
